"use client";
import { useRouter } from "next/navigation";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import Button from "@stadium/shared/src/components/shared/button";

import { BYSTADIUM_BOOK_A_CALL } from "@stadium/helpers/app-routes";

import styles from "./main.module.scss";

const RecognitionBanner = () => {
  const { push } = useRouter();
  const bookACallCtaText = useConfig(getBookACallCtaText);
  const handleTalkToSalesClick = () => {
    const bookACallForm = document.getElementById("book-a-call");
    if (bookACallForm) {
      bookACallForm.scrollIntoView?.({ behavior: "smooth", block: "nearest" });
      return;
    }
    push(BYSTADIUM_BOOK_A_CALL);
  };
  return (
    <section className={styles.recognitionSection}>
      <div className={styles.recognitionContentBlock}>
        <div className={styles.recognitionContentBlockLeft}>Kudos Program</div>
        <div className={styles.recognitionContentBlockRight}>
          <div>
            <div className={styles.recognitionContentPricingText}>Pricing per user/month</div>
            <div className={styles.recognitionContentBillingText}>Billed Anually</div>
          </div>
          <div className={styles.recognitionContentCtaBlock}>
            <Button
              className={styles.expertSpeakBtn}
              onClick={() => handleTalkToSalesClick()}
              title={bookACallCtaText}
            >
              {bookACallCtaText}
            </Button>
          </div>
        </div>
      </div>
      <footer className={styles.recognitionFooter}>
        <div className={styles.recognitionFooterTag}>Employee-to-Employee</div>
        <div className={styles.recognitionFooterTag}>recognition feed &amp; leaderboards</div>
        <div className={styles.recognitionFooterTag}>Company Values</div>
        <div className={styles.recognitionFooterTag}>slack &amp; teams integrations</div>
      </footer>
    </section>
  );
};

export default RecognitionBanner;
